import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { ApiRoutes, QueryKeyEnum, TimeEnum } from '@lib/enums';
import { useHttp } from '@lib/http';
import type { PermissionsEnum } from '@lib/enums';
import type { TPermissionsTable } from '@models/authorization/TPermissionsTable';
import type { TUser } from '@models/authorization/TUser';
import type { UseQueryResult } from '@tanstack/react-query';
export function useQueryGetMyUser(t0) {
  const $ = _c(8);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  const {
    http
  } = useHttp();
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [QueryKeyEnum.MyUser];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== http) {
    t3 = async () => {
      const data = await http.get(ApiRoutes.Users.Mine).send();
      const permissionsTable = {
        permissions: {},
        roles: {}
      } as TPermissionsTable;
      data.roles.forEach(role => role.rolePermissions.forEach(p => {
        const key = p.permissionId as PermissionsEnum;
        if (permissionsTable.permissions[key] != null) {
          return;
        }
        permissionsTable.permissions[key] = p.permissionName;
      }));
      return {
        ...data,
        permissionsTable,
        bannedTfnAreaCodes: ["229", "800", "888"]
      };
    };
    $[3] = http;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== options || $[6] !== t3) {
    t4 = {
      queryKey: t2,
      queryFn: t3,
      staleTime: TimeEnum.TwelveHours,
      gcTime: TimeEnum.TwelveHours,
      ...options
    };
    $[5] = options;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return useQuery(t4);
}